import React, { useEffect, useRef, useState } from "react";

import Checkbox from '@mui/material/Checkbox';
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import FormGroup from "@mui/material/FormGroup"
import FormHelperText from "@mui/material/FormHelperText"
import Typography from "@mui/material/Typography"

import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@mui/material/styles";

interface AddColumnButtonProps {
    allFacts: Array<string>
    selectedFacts: Array<string>
    toggleFact: Function
}

const AddColumnButton = ({ allFacts, selectedFacts, toggleFact }: AddColumnButtonProps) => {
    
    const columnNameInput = useRef();

    useEffect(() => {
        const node = columnNameInput.current as any;
        if (node) node.focus();
    });

    const [anchorEl, setAnchorEl] = useState(null);

    const openPopover = (ev: any) => {
        setAnchorEl(ev.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isChecked = (fact: string) => {
        return selectedFacts.includes(fact);
    }

    const handleChange = (fact: string) => {
        toggleFact(fact)
    }

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
      <>
        <Button id="open-button" onClick={openPopover}>
          Columns (<Typography color="primary">{allFacts.length}</Typography>)
        </Button>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div className="small-popover">
            <FormControl
              component="fieldset"
              sx={{ margin: (theme) => theme.spacing(3) }}
            >
              <FormLabel component="legend">Show: </FormLabel>
              <FormGroup>
                {allFacts.map((fact, i) => {
                  return (
                    <FormControlLabel
                      key={i}
                      control={
                        <Checkbox
                          checked={isChecked(fact)}
                          onChange={() => handleChange(fact)}
                          value={fact}
                        />
                      }
                      label={fact}
                    />
                  );
                })}
              </FormGroup>
            </FormControl>
          </div>
        </Popover>
      </>
    );
};

export default AddColumnButton;
